'use client';

import React, { useState, useEffect, useRef } from 'react';
import Link from 'next/link';

function Navigation() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
  { label: 'Home', href: '/' },
  { label: 'About', href: '/about' },
  { label: 'Our Wines', href: '/wines' },
  { label: 'Winemaking', href: '/winemaking' },
  { label: 'Team', href: '/team' },
  { label: 'Contact', href: '/contact' }];


  return (
    <>
      <div className="fixed inset-0 z-[100] flex flex-col items-center justify-center transition-all duration-500"
      style={{ background: 'rgba(10,7,5,0.97)', backdropFilter: 'blur(20px)', opacity: menuOpen ? 1 : 0, pointerEvents: menuOpen ? 'auto' : 'none' }}>
        <button className="absolute top-6 right-6 p-2 text-[#F5EDD6] hover:text-[#C9A84C] transition-colors" aria-label="Close menu" onClick={() => setMenuOpen(false)}>
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M18 6L6 18M6 6l12 12" strokeLinecap="round" /></svg>
        </button>
        <nav className="flex flex-col gap-8 text-center">
          {navLinks.map((link) =>
          <Link key={link.href + link.label} href={link.href}
          className="font-display text-3xl font-medium italic text-[#F5EDD6] hover:text-[#C9A84C] transition-colors duration-300"
          onClick={() => setMenuOpen(false)}>{link.label}</Link>
          )}
        </nav>
        <div className="mt-10 text-[#9A8A72] text-xs font-sans uppercase tracking-[0.3em]">Est. 1850 · Pauillac, France</div>
      </div>

      <nav className="fixed z-50 top-0 inset-x-0 px-6 py-3 flex items-center justify-between transition-all duration-500"
      style={{ background: scrolled ? 'rgba(10,7,5,0.85)' : 'transparent', backdropFilter: scrolled ? 'blur(12px)' : 'none', borderBottom: scrolled ? '1px solid rgba(46,26,16,0.6)' : 'none' }}>
        <Link href="/" className="flex items-center gap-3 group">
          <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center">
            <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
              <circle cx="20" cy="20" r="19" stroke="#C9A84C" strokeWidth="1" strokeOpacity="0.6" />
              <path d="M20 8 L24 16 L32 17 L26 23 L28 31 L20 27 L12 31 L14 23 L8 17 L16 16 Z" fill="none" stroke="#C9A84C" strokeWidth="1" />
              <circle cx="20" cy="20" r="3" fill="#C9A84C" fillOpacity="0.5" />
            </svg>
          </div>
          <div className="hidden sm:flex flex-col leading-none">
            <span className="font-display text-base font-semibold tracking-[0.2em] text-[#F5EDD6] uppercase">Baron Castle</span>
            <span className="text-[9px] font-sans tracking-[0.35em] text-[#C9A84C] uppercase mt-0.5">Château Baron · Est. 1850</span>
          </div>
        </Link>
        <div className="hidden lg:flex items-center gap-7">
          {navLinks.map((link) =>
          <Link key={link.href + link.label} href={link.href}
          className="text-sm font-medium text-[#9A8A72] hover:text-[#F5EDD6] transition-colors duration-300 relative group">
              {link.label}
              <span className="absolute -bottom-0.5 left-0 w-0 h-px bg-[#C9A84C] group-hover:w-full transition-all duration-300" />
            </Link>
          )}
        </div>
        <div className="flex items-center gap-3">
          <Link href="/contact" className="hidden md:inline-flex items-center gap-2 px-5 py-2 border border-[#C9A84C]/50 text-[#C9A84C] text-xs font-semibold uppercase tracking-widest hover:bg-[#C9A84C] hover:text-[#0A0705] transition-all duration-300">
            Visit Estate
          </Link>
          <button className="lg:hidden p-2 text-[#F5EDD6] hover:text-[#C9A84C] transition-colors" aria-label="Open menu" onClick={() => setMenuOpen(true)}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M4 6h16M4 12h16M4 18h16" strokeLinecap="round" /></svg>
          </button>
        </div>
      </nav>
    </>);

}

function Footer() {
  return (
    <footer className="border-t border-[#2E1A10] bg-[#0A0705] pt-16 pb-8">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        <div className="flex flex-col lg:flex-row justify-between items-start gap-12 mb-12">
          <div className="max-w-sm">
            <div className="flex items-center gap-3 mb-4">
              <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
                <circle cx="20" cy="20" r="19" stroke="#C9A84C" strokeWidth="1" strokeOpacity="0.6" />
                <path d="M20 8 L24 16 L32 17 L26 23 L28 31 L20 27 L12 31 L14 23 L8 17 L16 16 Z" fill="none" stroke="#C9A84C" strokeWidth="1" />
                <circle cx="20" cy="20" r="3" fill="#C9A84C" fillOpacity="0.5" />
              </svg>
              <div className="flex flex-col leading-none">
                <span className="font-display text-lg font-semibold tracking-[0.2em] text-[#F5EDD6] uppercase">Baron Castle</span>
                <span className="text-[9px] font-sans tracking-[0.35em] text-[#C9A84C] uppercase mt-0.5">Château Baron · Est. 1850</span>
              </div>
            </div>
            <p className="text-[#9A8A72] text-sm leading-relaxed italic font-display">A historic Bordeaux château crafting wines of extraordinary depth and elegance since 1850.</p>
            <p className="text-[#9A8A72] text-xs mt-4 font-sans">Route des Châteaux, Saint Lambert<br />33250 Pauillac, Gironde, France</p>
          </div>
          <div className="flex flex-wrap gap-x-16 gap-y-8">
            <div className="flex flex-col gap-3">
              <span className="text-xs font-sans uppercase tracking-widest text-[#C9A84C] mb-1">Estate</span>
              <Link href="/" className="text-sm text-[#9A8A72] hover:text-[#F5EDD6] transition-colors">Home</Link>
              <Link href="/about" className="text-sm text-[#9A8A72] hover:text-[#F5EDD6] transition-colors">Our Heritage</Link>
              <Link href="/winemaking" className="text-sm text-[#9A8A72] hover:text-[#F5EDD6] transition-colors">Winemaking</Link>
            </div>
            <div className="flex flex-col gap-3">
              <span className="text-xs font-sans uppercase tracking-widest text-[#C9A84C] mb-1">Discover</span>
              <Link href="/wines" className="text-sm text-[#9A8A72] hover:text-[#F5EDD6] transition-colors">Our Wines</Link>
              <Link href="/team" className="text-sm text-[#9A8A72] hover:text-[#F5EDD6] transition-colors">Team & Investors</Link>
              <Link href="/contact" className="text-sm text-[#9A8A72] hover:text-[#F5EDD6] transition-colors">Visit Us</Link>
            </div>
          </div>
        </div>
        <div className="border-t border-[#2E1A10] pt-6 flex flex-col sm:flex-row justify-between items-center gap-4">
          <span className="text-xs text-[#9A8A72] font-sans">© 2025 圣兰博之围 · Château Baron, Pauillac AOC · All rights reserved</span>
        </div>
      </div>
    </footer>);

}

interface FormState {
  name: string;
  email: string;
  subject: string;
  message: string;
}

export default function ContactPage() {
  const formRef = useRef<HTMLDivElement>(null);
  const [formVisible, setFormVisible] = useState(false);
  const [form, setForm] = useState<FormState>({ name: '', email: '', subject: '', message: '' });
  const [submitted, setSubmitted] = useState(false);

  useEffect(() => {
    const el = formRef.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      ([entry]) => {if (entry.isIntersecting) {setFormVisible(true);observer.unobserve(el);}},
      { threshold: 0.1 }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  function handleChange(e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) {
    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  }

  function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setSubmitted(true);
  }

  const inputClass = "w-full bg-transparent border-b border-[#2E1A10] focus:border-[#C9A84C] text-[#F5EDD6] text-sm py-3 outline-none transition-colors duration-300 placeholder:text-[#9A8A72]/50 font-sans";

  return (
    <main className="bg-[#0A0705] text-[#F5EDD6] overflow-x-hidden" style={{ fontFamily: "'DM Sans', sans-serif" }}>
      <Navigation />

      {/* Hero */}
      <section className="relative pt-32 pb-0 overflow-hidden">
        <div className="relative">
          <img
            src="https://images.unsplash.com/photo-1665170324470-a6da1edcf119?w=1600&q=80"
            alt="Vineyard entrance gate with stone wall and tall iron gate at Baron Castle estate in Pauillac"
            className="w-full object-cover"
            style={{ aspectRatio: '21/9', filter: 'brightness(0.4)' }} />
          
          <div className="absolute inset-0 flex flex-col justify-end px-6 lg:px-16 pb-16 max-w-[1400px] mx-auto">
            <div className="flex items-center gap-3 mb-4">
              <span className="w-8 h-px bg-[#C9A84C]" />
              <span className="font-sans text-xs uppercase tracking-[0.3em] text-[#C9A84C]">Route des Châteaux · Pauillac</span>
            </div>
            <h1 className="font-display font-medium text-[#F5EDD6] leading-none select-none" style={{ fontSize: 'clamp(4rem, 12vw, 12rem)' }}>
              Visit the Estate
            </h1>
            <p className="font-display italic text-lg md:text-xl text-[#F5EDD6]/70 max-w-2xl leading-relaxed mt-4">
              We welcome visitors to experience 圣兰博之围 firsthand — the terroir, the cellars, and the wines that have defined Pauillac for 175 years.
            </p>
          </div>
        </div>
      </section>

      {/* Content */}
      <section className="py-24 px-6 lg:px-16 max-w-[1400px] mx-auto">
        <div
          ref={formRef}
          className="grid grid-cols-1 lg:grid-cols-[1fr_1.6fr] gap-16 lg:gap-24"
          style={{ opacity: formVisible ? 1 : 0, transform: formVisible ? 'translateY(0)' : 'translateY(40px)', transition: 'opacity 0.9s ease, transform 0.9s ease' }}>

          {/* Left: info */}
          <div className="flex flex-col gap-10">
            <div>
              <h3 className="font-sans text-xs uppercase tracking-[0.25em] text-[#C9A84C] mb-4">Estate Address</h3>
              <p className="text-[#9A8A72] leading-relaxed text-sm">
                Château Baron Castle<br />
                Route des Châteaux<br />
                Saint-Lambert<br />
                33250 Pauillac, Gironde<br />
                France
              </p>
            </div>
            <div>
              <h3 className="font-sans text-xs uppercase tracking-[0.25em] text-[#C9A84C] mb-4">Visiting Hours</h3>
              <div className="flex flex-col gap-2 text-sm">
                <div className="flex justify-between">
                  <span className="text-[#9A8A72]">Monday – Friday</span>
                  <span className="text-[#F5EDD6]">09:00 – 17:00</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-[#9A8A72]">Saturday</span>
                  <span className="text-[#F5EDD6]">10:00 – 15:00</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-[#9A8A72]">Sunday</span>
                  <span className="text-[#F5EDD6]">By appointment only</span>
                </div>
              </div>
              <p className="text-[#9A8A72] text-xs mt-4 leading-relaxed">
                Cellar tours and private tastings available by prior arrangement. Please contact us at least 48 hours in advance.
              </p>
            </div>
            <div>
              <h3 className="font-sans text-xs uppercase tracking-[0.25em] text-[#C9A84C] mb-4">Contact</h3>
              <p className="text-[#9A8A72] text-sm mb-1">contact@baroncastle.fr</p>
              <p className="text-[#9A8A72] text-sm">+33 (0)5 56 59 00 00</p>
            </div>
            <div className="border-t border-[#2E1A10] pt-8">
              <p className="text-[#9A8A72] text-xs leading-relaxed">
                Saint-Lambert · 33250 Pauillac<br />
                Médoc Peninsula · Gironde · France
              </p>
            </div>
          </div>

          {/* Right: form */}
          <div>
            <h2 className="font-display font-medium text-[#F5EDD6] text-2xl mb-2">Send an Enquiry</h2>
            <p className="text-[#9A8A72] text-sm mb-10">We Would Be Delighted to Hear from You</p>

            {submitted ?
            <div className="flex flex-col items-start gap-6 py-12">
                <div className="w-12 h-12 border border-[#C9A84C]/40 flex items-center justify-center">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#C9A84C" strokeWidth="1.5"><path d="M20 6L9 17l-5-5" strokeLinecap="round" strokeLinejoin="round" /></svg>
                </div>
                <h3 className="font-display font-medium text-[#F5EDD6] text-2xl">Enquiry received.</h3>
                <p className="text-[#9A8A72] text-sm leading-relaxed max-w-sm">Thank you for writing to us. We respond to all enquiries within 48 hours. For urgent matters, please call us directly.</p>
                <button onClick={() => setSubmitted(false)} className="mt-4 text-xs font-sans uppercase tracking-widest text-[#C9A84C] hover:text-[#F5EDD6] transition-colors">
                  Send another enquiry →
                </button>
              </div> :

            <form onSubmit={handleSubmit} className="flex flex-col gap-8">
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
                  <div>
                    <label className="block text-xs font-sans uppercase tracking-[0.2em] text-[#9A8A72] mb-2">Full Name</label>
                    <input type="text" name="name" value={form.name} onChange={handleChange} required placeholder="Your full name" className={inputClass} />
                  </div>
                  <div>
                    <label className="block text-xs font-sans uppercase tracking-[0.2em] text-[#9A8A72] mb-2">Email Address</label>
                    <input type="email" name="email" value={form.email} onChange={handleChange} required placeholder="your@email.com" className={inputClass} />
                  </div>
                </div>
                <div>
                  <label className="block text-xs font-sans uppercase tracking-[0.2em] text-[#9A8A72] mb-2">Subject</label>
                  <select name="subject" value={form.subject} onChange={handleChange} required className={inputClass + " cursor-pointer"}>
                    <option value="" disabled className="bg-[#0A0705]">Select a subject</option>
                    <option value="visit" className="bg-[#0A0705]">Estate Visit & Tasting</option>
                    <option value="purchase" className="bg-[#0A0705]">Wine Purchase Enquiry</option>
                    <option value="trade" className="bg-[#0A0705]">Trade & Distribution</option>
                    <option value="press" className="bg-[#0A0705]">Press & Media</option>
                    <option value="general" className="bg-[#0A0705]">General Enquiry</option>
                  </select>
                </div>
                <div>
                  <label className="block text-xs font-sans uppercase tracking-[0.2em] text-[#9A8A72] mb-2">Message</label>
                  <textarea name="message" value={form.message} onChange={handleChange} required placeholder="Your message..." rows={5}
                className={inputClass + " resize-none"} />
                </div>
                <div>
                  <button type="submit"
                className="inline-flex items-center gap-3 px-8 py-3 bg-[#C9A84C] text-[#0A0705] text-xs font-semibold uppercase tracking-widest hover:bg-[#F5EDD6] transition-all duration-300">
                    Send Enquiry
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M5 12h14M12 5l7 7-7 7" strokeLinecap="round" strokeLinejoin="round" /></svg>
                  </button>
                  <p className="text-[#9A8A72] text-xs mt-4">We respond to all enquiries within 48 hours. For urgent matters, please call us directly.</p>
                </div>
              </form>
            }
          </div>
        </div>
      </section>

      <Footer />
    </main>);

}